import Datetimepicker from './datetimepicker.vue'

const MyDatetimepicker = {
  install: function (Vue) {
    Vue.component('Datetimepicker', Datetimepicker)
  }
}

export default MyDatetimepicker



// WEBPACK FOOTER //
// ./src/components/datetimepicker/index.js